<template>
  <div class="card p-6 mb-2">
    <h6 class="mb-6">Releaseinformationen</h6>
    <div class="d-flex align-items-center" style="gap: 16px">
      <b-form-group v-if="editedSeason.releasefrist?.length === 0" label="Releasefrist">
        <div class="bg-primary plus-sign" @click="onAddReleasefrist">+</div>
      </b-form-group>
      <div v-for="item in editedSeason.releasefrist" :key="'releasefrist-' + item.id">
        <b-form-group class="widthEditField">
          <template #label>
            <div class="d-flex align-items-center" style="gap: 4px">
              <div>{{ `${item.id}. Releasefrist` }}</div>
              <div
                class="bg-primary plus-sign"
                v-if="editedSeason.releasefrist?.length === item.id"
                @click="onRemoveReleasefrist"
              >
                -
              </div>
              <div
                v-if="editedSeason.releasefrist?.length === item.id"
                class="bg-primary plus-sign"
                @click="onAddReleasefrist"
              >
                +
              </div>
            </div>
          </template>
          <!-- Feld gilt als geändert, wenn die Frist neu ist (Position über dem geladenen Stand) oder ihr Wert vom Ursprungswert abweicht -->
          <b-form-input
            :class="{
              changed:
                item.id > activeMetadata.releasefrist?.length ||
                +activeMetadata.releasefrist?.[item.id - 1] !== item.value,
            }"
            size="sm"
            v-model="item.value"
            :number="true"
            type="number"
            min="0"
            max="365"
            step="1"
            required
          ></b-form-input>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReisenMetadataCardReleaseinformationen',
  props: {
    editedSeason: { type: Object, required: true },
    activeMetadata: { type: Object, default: null },
  },
  methods: {
    // Hängt eine weitere Releasefrist an
    onAddReleasefrist() {
      const length = this.editedSeason.releasefrist.length;
      this.editedSeason.releasefrist = [...this.editedSeason.releasefrist, { value: 0, id: length + 1 }];
    },
    // Entfernt die zuletzt hinzugefügte Releasefrist
    onRemoveReleasefrist() {
      this.editedSeason.releasefrist.pop();
    },
  },
};
</script>

<style lang="scss" scoped>
.widthEditField {
  width: 225px;
}

.plus-sign {
  height: 24px;
  width: 24px;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: white;
  cursor: pointer;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

:deep(.changed) {
  background-color: #3699ff50;
}
</style>
